export default {
  apiKey: 'AIzaSyBADcOJtn4eZEY4v_R22ILHOkbHis9Knc4',
  authDomain: 'intrihub-98da3.firebaseapp.com',
  databaseURL: 'https://intrihub-98da3.firebaseio.com',
  storageBucket: 'intrihub-98da3.appspot.com',
  messagingSenderId: '1085157336669'
}



// WEBPACK FOOTER //
// ./src/firebaseRef.js